import DashboardGrid from '@/components/dashboard/dashboard-grid/dashboard-grid';
import Resources from '@/components/resources/resources';
import { Button, Flex, IconArrowDown, Text } from '@cmpsr/components';
import React from 'react';
import useCompletedTestController from './completed-testing-plan.controller';
import CompletedTest from './components/completed-test/completed-test';
import EmptyState from './components/empty-state/empty-state';
import ReducedRiskEncouragement from './components/reduced-risk-encouragement/reduced-risk-encouragement';
import { CompletedTestPlan } from './types';

function CompletedTestingPlans() {
  const { completedTests, firstReducedRisk, loadMore, showLoadMoreButton } = useCompletedTestController();

  if (!completedTests) return <EmptyState />;

  return (
    <DashboardGrid>
      <Flex as="main" direction="column" gap={6} w="full">
        {Object.keys(completedTests).map((testsMonth) => (
          <Flex direction="column" gap="spacer-4" key={testsMonth}>
            <Text variant="text-header-XS">{testsMonth}</Text>

            {completedTests[testsMonth].map((testData: CompletedTestPlan) => (
              <CompletedTest {...testData} key={testData.id} />
            ))}
            {!!firstReducedRisk && testsMonth === firstReducedRisk.month && (
              <ReducedRiskEncouragement
                date={firstReducedRisk.date}
                type={firstReducedRisk.type}
                idType={firstReducedRisk.idType}
              />
            )}
          </Flex>
        ))}
        {showLoadMoreButton && (
          <Button
            onClick={loadMore}
            variant="ghost"
            trailingIcon={<IconArrowDown size="xs" />}
            border="1px solid"
            borderColor="ui-element-divider"
            borderRadius="radii-3"
          >
            Load more
          </Button>
        )}
      </Flex>
      <Resources as="aside" w="full" />
    </DashboardGrid>
  );
}

export default React.memo(CompletedTestingPlans);
